<template>
  <button>-</button>
</template>
  
  <style scoped>
button {
  display: flex;
  justify-content: center;
  align-items: center;

  border: 1px solid rgba(0, 0, 0, 0.16);
  border-radius: 50%;
  background: #fff;
  outline: none;

  height: 25px;
  width: 25px;

  font-size: 1.5rem;
  font-weight: 500;
}

button:disabled {
  background: rgba(0, 0, 0, 0.08);
  border: none;
}
</style>